import React from 'react'
import { Button, Col, Progress, Row, Badge, Divider } from 'antd'
import styles from './UploadControl.module.scss'
import LoadingArea from '../Loaders/LoadingArea'
import { UploadJobControl } from '../components'
import { useComponentLocale } from '../hooks/useComponentLocale'
import {RefreshIcon} from "../helpers/icons";

function UploadStatistic({ refreshUploads, taskList, isTaskRequest, onButtonStatusClicked }) {
	const getLocale = useComponentLocale()
	const myUploadsLocale = getLocale({ component: 'uploadPage', section: 'my_uploads' })
	const refreshBtnLocale = getLocale({ component: 'common_buttons', section: 'refresh' })
	const processedStatusLocale = getLocale({ component: 'uploadPage', section: 'status_processed' })
	const overallStatusLocale = getLocale({ component: 'uploadPage', section: 'status_overall' })
	const errorStatusLocale = getLocale({ component: 'uploadPage', section: 'status_error' })

	// legend sections
	const sections = [
		{
			name: processedStatusLocale,
			color: '#43E090',
		},
		{
			name: overallStatusLocale,
			color: '#80AAFF',
		},
		{
			name: errorStatusLocale,
			color: '#FF897A',
		},
	]

	const renderLimits = (limits) => {
		if (!limits) {
			return null
		}

		const lts = []
		for (let i = 0; i < limits.length; i++) {
			lts.push(
				<div className={styles.limitBlock}>
					<div className={styles.limitTitle}>
						<span>{limits[i].name}</span>
						<span>
							{limits[i].count} / {limits[i].limit}
						</span>
					</div>
					<div>
						<Progress
							size='small'
							showInfo={false}
							percent={(limits[i].count / limits[i].limit) * 100}
							strokeColor='#5C8EF0'
						/>
					</div>
				</div>
			)
		}

		return lts
	}

	return (
		<Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.uploadControlArea}>
			<Row className={styles.controlAreaHeader}>
				<span>
					<h1>{myUploadsLocale}</h1>
				</span>
				<span>
					<Button onClick={refreshUploads} icon={<RefreshIcon />} className={styles.refreshButton} />
				</span>
			</Row>

			<Divider className={styles.divider} />

			{taskList && !isTaskRequest ? <Row>{renderLimits(taskList.limits)}</Row> : null}

			<Row className={styles.controlAreaBody}>
				{isTaskRequest ? (
					<LoadingArea />
				) : (
					<UploadJobControl taskList={taskList} onButtonStatusClicked={onButtonStatusClicked} />
				)}
			</Row>

			<Row className={styles.actionsLegend}>
				<Col span={24}>
					{sections.map(({ name, color }) => (
						<Badge key={name} color={color} text={name} className={styles.actionsLegendItem} />
					))}
				</Col>
			</Row>
		</Col>
	)
}

export default UploadStatistic
